var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPytorch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1846 34.1673C50.184 36.256 51.3333 39.0473 51.3333 42C51.3333 48.2493 46.2493 53.3333 40 53.3333C33.7506 53.3333 28.6666 48.2493 28.6666 42C28.6666 36.3213 34.5413 31.344 39.2626 27.3447C39.5153 27.1307 39.756 26.9253 40 26.7173V30.2173C35.91 33.706 31.3333 37.8913 31.3333 42C31.3333 46.7787 35.2213 50.6667 40 50.6667C44.7786 50.6667 48.6666 46.7787 48.6666 42C48.6666 39.7147 47.758 37.562 46.194 35.9587L48.1846 34.1673ZM44 30.6667C43.2633 30.6667 42.6666 31.2633 42.6666 32C42.6666 32.7367 43.2633 33.3333 44 33.3333C44.7366 33.3333 45.3333 32.7367 45.3333 32C45.3333 31.2633 44.7366 30.6667 44 30.6667Z",
    fill: "url(#paint0_linear_158_247)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_158_247",
    x1: 36.4,
    y1: 30.9353,
    x2: 43.4113,
    y2: 52.4907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPytorch);
export default __webpack_public_path__ + "static/media/pytorch.3d9bfca277e33daa34edb1f311d0caa1.svg";
export { ForwardRef as ReactComponent };